import type { locations as Fr } from '../fr/locations';

/** « locations » in English — typed on the French: a missing sentence does not compile. */
export const locations: typeof Fr = {
  filtres: { en_cours: 'In progress', a_venir: 'Upcoming', terminees: 'Completed', toutes: 'All' },
  titre: 'My rentals',
  sousTitre: 'All your rentals, from quote to return · click to open the file',
  nouvelle: 'New rental',
  recherche: 'Number, customer, make or plate…',
  aucuneCorrespond: 'No rental matches',
  aucuneIci: 'No rentals here',
  creer: 'Create a rental',
  essayez: 'Try the customer name or the plate, or change the filter.',
  changezFiltre: 'Change the filter to see past or upcoming rentals.',
  colNumero: 'No.', colClient: 'Customer', colVehicule: 'Vehicle', colPeriode: 'Period', colTotal: 'Expected total', colStatut: 'Status',
  pied: (n: number, total: number | null) =>
    `${n} ${n === 1 ? 'rental' : 'rentals'} shown${total !== null ? ` out of ${total}` : ''}. A rental file holds its rental agreement, deposit, inspection and balance due.`,
};
